import { Modal, ModalContent, ModalFooter, ModalManager } from "../../Modal";
import { Button } from "../../Button";
import React, { ReactNode } from "react";

type IGuideProps = {
  show: boolean;
  onClose: () => any;
  onAction: () => any;
  actionText: string;
  content: ReactNode;
};

export const GuideModal = ({
  show,
  onClose,
  onAction,
  actionText,
  content,
}: IGuideProps) => {
  return (
    <ModalManager onClose={onClose} showModal={show}>
      <Modal fitWidth style={{ height: "auto" }}>
        <ModalContent>{content}</ModalContent>
        <ModalFooter alignLeft>
          <Button onClick={onAction}>{actionText}</Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
